// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-attachment-main-container {
  width: 325px;
  height: 250px;
}
.file-attachment-main-container .file-attachment-container {
  height: 100%;
  border-radius: 20px;
  box-shadow: 0px 3px 6px 0px rgba(140, 149, 159, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.file-attachment-main-container .file-attachment-container .file-attachment {
  max-width: 325px;
  max-height: 250px;
}`, "",{"version":3,"sources":["webpack://./src/component/common/fileAttachment/FileAttachment.scss"],"names":[],"mappings":"AACA;EACE,YAAA;EACA,aAAA;AAAF;AAEE;EACE,YAAA;EACA,mBAAA;EACA,qDAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AAEI;EACE,gBAAA;EACA,iBAAA;AAAN","sourcesContent":["\n.file-attachment-main-container {\n  width: 325px;\n  height: 250px;\n  \n  .file-attachment-container {\n    height: 100%;\n    border-radius: 20px;\n    box-shadow: 0px 3px 6px 0px rgba(140, 149, 159, 0.15);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    \n    .file-attachment {\n      max-width: 325px;\n      max-height: 250px;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
